import { AngularFireAuth } from "@angular/fire/compat/auth";
import firebase from "firebase/compat";

/**
 * Abstraction around firebase/auth's `User` interface,
 * to more easily mock it for local offline testing.
 *
 * Should include all the properties of user that
 * are actually used by the app.
 */
export interface AppUser
  extends PartialRequired<
    firebase.User,
    "email" | "displayName" | "uid" | "providerData"
  > {}

/**
 * Abstraction around AngularFire's `Auth` interface,
 * to more easily mock it for local offline testing.
 *
 * Should include the hooks that are actually used by the app.
 */
export interface AppAuth extends Pick<AngularFireAuth, "onAuthStateChanged"> {
  currentUser: AppUser | null;
}

/**
 * This interface and type predicate check reflects the e-mail
 * address for the authorized user assumed by the pdf generation code
 */
export interface UserWithEmail extends AppUser {
  email: string;
}
export function isUserWithEmail(user: any): user is UserWithEmail {
  return !!user && typeof user.email === "string";
}

/**
 * type helper: make some properties required, and others optional
 */
type PartialRequired<T, RequiredProperties extends keyof T> = Required<
  Pick<T, RequiredProperties>
> &
  Partial<Omit<T, RequiredProperties>>;
